import firebaseApp from "../firebase/credenciales";
import { getFirestore, collection, getDocs, query, where, orderBy } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function getAllFormularios(baseDatos, ruc) {

  const productos = [];
  const collectionRef = collection(db, baseDatos);
  const q = query(collectionRef
    , where("activo", "==", true), where ("ruc", "==", ruc)
    );
  const snapshot = await getDocs(q);
  snapshot.forEach((doc) => {
    productos.push(doc.data());
  });
  return productos;
  
}

